<template>
    <div
        class="day day-capacity"
        :style="$options.getStyle(date, currentZoom, itemCapacity)"
        :data-date="date.formatted"
        :data-itemid="itemId"
        @click.self="$options.handleClick(date, itemId)"
        @contextmenu.self.prevent="$options.handleRightClick($event, date, itemId)"
        @mouseover="$options.handleMouseOver($event, date, itemId)"
        @drop="$options.handleDrop($event, date, itemId)"
    >
        {{ $options.getCapacityTime(itemCapacity) }}
    </div>
</template>

<script>
import { ZOOM_SETTINGS } from '../../../constants';
import store from '../../../stores';
import { emitter } from '../../../plugins/Mitt';
import { getCapacityColor } from '../../../utils/capacity/getCapacityColor';
import { getCapacityTime } from '../../../utils/capacity/getCapacityTime';

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
        date: {
            type: Object,
        },
        currentZoom: {
            type: Number,
        },
        itemCapacity: {
            required: true,
        },
    },
    getStyle(date, currentZoom, itemCapacity) {
        return {
            backgroundColor: getCapacityColor(itemCapacity),
            width: ZOOM_SETTINGS[currentZoom].dayWidth[date.localDate.dayOfWeek().value()] + 'px',
        };
    },
    getCapacityTime,
    handleClick(date, itemId) {
        let eventObject = {
            date: date.formatted,
        };

        const mode = store.state.planning.mode;

        if (mode === 'capacityPerson') {
            eventObject.personId = itemId;
        } else if (mode === 'capacityTeam') {
            eventObject.teamId = itemId;
        }

        emitter.emit('open-planning-date-details', eventObject);
    },
    handleRightClick($event, date, itemId) {
        window.removeEventListener('onmouseover', this.handleMouseOver);
        let eventObject = {
            date: date,
        };
        const mode = store.state.planning.mode;

        if (mode === 'capacityPerson') {
            eventObject.personId = itemId;
        } else if (mode === 'capacityPeam') {
            eventObject.teamId = itemId;
        }

        emitter.emit('show-context-menu-component', { eventObject: eventObject, event: $event });
    },
    handleMouseOver($event, date, itemId) {
        if (store.state.planning.isDragging) {
            return;
        }
        if (!itemId) {
            return;
        }
        const mode = store.state.planning.mode;

        let eventObject = {
            date: date,
            mode: mode,
        };

        if (mode === 'capacityPerson') {
            eventObject.personId = itemId;
        } else if (mode === 'capacityTeam') {
            eventObject.teamId = itemId;
        }

        emitter.emit('show-day-hover-info', {
            eventObject: eventObject,
            event: $event,
        });
    },
    handleDrop($event, date, itemId) {
        let taskId = $event.dataTransfer.getData('taskId');
        if (!taskId) {
            return;
        }
        console.log(date);
        let eventObject = {
            dateStart: date.formatted,
            dateEnd: date.formatted,
            timeStart: '08:00', // Todo
            timeEnd: '16:00', // Todo
            taskId: parseInt(taskId),
            personId: itemId,
        };

        emitter.emit('open-planning-form', eventObject);
    },
};
</script>

<style></style>
